{
  "breadcrumb": {
    "root": "BLIKS IO",
    "dashboard": "Mon environnement de travail",
    "recordingDashboard": "Cockpit d'enregistrement",
    "organization": "Catalogues de l'organisation",
    "organigram": "Organigramme",
    "processes": "Processus",
    "departments": "Départements",
    "myOrgFunctions": "Mes fonctions",
    "functions": "Fonctions",
    "teams": "Équipes",
    "systems": "Systèmes",
    "externalContacts": "Contacts externes",
    "artifacts": "Documents",
    "orgMembers": "Personnes",
    "allProcesses": "Tous les processus",
    "processEditor": "Éditeur de processus",
    "myTasks": "Mes tâches",
    "organizationSettings": "Paramètres",
    "dataSync": "Synchronisation des données",
    "initialSetup": "Configuration initiale",
    "setupPending": "Configuration en cours",
    "seatOverrun": "Organisation verrouillée",
    "processMap": "Cartographie des processus",
    "processChains": "Chaînes de processus",
    "systemLandscape": "Paysage système",
    "admin": "Admin",
    "tenants": "Locataires",
    "accounts": "Comptes",
    "users": "Utilisateurs",
    "partnerContent": "Contenus partenaires",
    "createProcesses": "Créer des processus",
    "shadowSystems": "Systèmes fantômes",
    "departmentsBulkUpload": "Import en masse de départements",
    "userManagement": "Gestion des utilisateurs",
    "apps": "Applications",
    "auditLogs": "Journal d'audit",
    "recordingAnalytics": "Analyses d'enregistrement",
    "aiUsage": "Utilisation de l'IA",
    "partner": "Partenaire",
    "leads": "Leads",
    "tasks": "Tâches",
    "helpCenter": "Service client",
    "supportTickets": "Tickets de support"
  },
  "notifications": {
    "title": "Notifications",
    "empty": "Aucune notification"
  }
}
